import { createRoute, useNavigate } from "@tanstack/solid-router";
import { adminRoute } from "./admin";
import { EmailTemplateManager } from "@/features/admin/components/email-template-manager";
import { PageContainer } from "@fleet/ui";

/**
 * `/admin/email/new` — URL-addressable template creation editor
 * (campaign #15b). It used to be a local signal (`creating`) without its own URL.
 * Static segment: it takes precedence over `$templateId` in the router.
 */
function AdminEmailNewPage() {
  const navigate = useNavigate();
  const back = () => {
    void navigate({ to: "/admin/email" });
  };
  return (
    <PageContainer maxWidth="6xl">
      <EmailTemplateManager
        mode={() => "new"}
        onClose={back}
        onNew={back}
        onEdit={(id) => {
          void navigate({ to: "/admin/email/$templateId", params: { templateId: id } });
        }}
      />
    </PageContainer>
  );
}

export const adminEmailNewRoute = createRoute({
  getParentRoute: () => adminRoute,
  path: "/email/new",
  component: AdminEmailNewPage,
});
